/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Section_FreetextInputs */

const en_company_registration_section_freetext = /** @type {(inputs: Company_Registration_Section_FreetextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional Information`)
};

const de_company_registration_section_freetext = /** @type {(inputs: Company_Registration_Section_FreetextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freitextfelder`)
};

/**
* | output |
* | --- |
* | "Additional Information" |
*
* @param {Company_Registration_Section_FreetextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_section_freetext = /** @type {((inputs?: Company_Registration_Section_FreetextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Section_FreetextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_section_freetext(inputs)
	return en_company_registration_section_freetext(inputs)
});